import { Button } from '../button'
import { Divider } from '../divider'
import { Dialog } from './dialog'

interface ConfirmDialogProps {
  isOpen: boolean
  title: React.ReactNode
  children: React.ReactNode
  onCancel: () => void
  onConfirm: () => void
  confirmLabel?: string
  cancelLabel?: string
  maxWidth?: string
}

const ConfirmDialog = (props: ConfirmDialogProps) => (
  <Dialog
    onClose={() => props.onCancel()}
    title={props.title}
    isOpen={props.isOpen}
    maxWidth={props.maxWidth || '400px'}
    noPadding
  >
    <div className="p-6">{props.children}</div>

    <Divider />
    <div className="flex justify-between gap-3 p-6">
      <Button
        className="flex-1"
        variant="outline"
        onClick={() => props.onCancel()}
        size="lg"
      >
        {props.cancelLabel || 'No'}
      </Button>

      <Button className="flex-1" onClick={() => props.onConfirm()} size="lg">
        {props.confirmLabel || 'Yes'}
      </Button>
    </div>
  </Dialog>
)

export { ConfirmDialog }
